import type { PackageJson } from '@wix/cli-fs';

interface DependencyOptions {
  dependencies?: Record<string, string>;
  devDependencies?: Record<string, string>;
}

type DependencyType = keyof DependencyOptions;

export function addMissingDependencies(
  packageJson: PackageJson,
  options: DependencyOptions
) {
  addMissingDependenciesOfType(packageJson, 'dependencies', options);
  addMissingDependenciesOfType(packageJson, 'devDependencies', options);
}

function addMissingDependenciesOfType(
  packageJson: PackageJson,
  type: DependencyType,
  options: DependencyOptions
) {
  for (const [key, value] of Object.entries(options[type] ?? {})) {
    if (packageJson.dependencies?.[key] || packageJson.devDependencies?.[key]) {
      continue;
    }
    if (!packageJson[type]?.[key]) {
      packageJson[type] ??= {};
      packageJson[type][key] = value;
    }
  }
}
